import React from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
import ContactForm from '../../components/common/ContactForm';
import { MapPin, Phone, Mail } from 'lucide-react';

const ContactUs = () => {
  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    },
    heroSection: {
      backgroundImage: `url(${require('../../assets/images/contactheroimage.png')})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative',
      color: 'white',
      padding: '200px 0 150px 0',
      minHeight: '70vh',
      textAlign: 'left'
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.3)'
    },
    heroContent: {
      position: 'relative',
      zIndex: 2,
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem'
    },
    heroLabel: {
      fontSize: '1.2rem',
      fontWeight: '400',
      marginBottom: '1rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1rem'
    },
    heroTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      marginBottom: '1rem',
      textTransform: 'uppercase'
    },
    actualShootBadge: {
      position: 'absolute',
      right: '2rem',
      bottom: '2rem',
      backgroundColor: 'rgba(255,255,255,0.9)',
      color: '#2c5f5f',
      padding: '0.8rem 1.5rem',
      borderRadius: '25px',
      fontSize: '0.9rem',
      fontWeight: '600',
      textTransform: 'uppercase'
    },
    contactInfoSection: {
      padding: '80px 0',
      backgroundColor: '#ffffff'
    },
    sectionContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem'
    },
    contactGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '4rem',
      textAlign: 'center',
      marginTop: '3rem'
    },
    contactItem: {
      textAlign: 'center'
    },
    iconContainer: {
      width: '80px',
      height: '80px',
      margin: '0 auto 2rem auto',
      backgroundColor: '#E67E22',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2rem'
    },
    contactTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#333',
      marginBottom: '1rem',
      textTransform: 'uppercase'
    },
    contactInfo: {
      fontSize: '1rem',
      color: '#666',
      lineHeight: '1.8'
    },
    formSection: {
      padding: '6rem 0',
      background: 'linear-gradient(135deg, #E67E22 0%, #D35400 100%)',
      color: 'white',
      textAlign: 'center'
    },
    formTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      margin: '0 0 3rem 0',
      textTransform: 'uppercase'
    },
    contactFormGrid: {
      maxWidth: '800px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '2rem'
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column'
    },
    inputLabel: {
      fontSize: '1rem',
      marginBottom: '0.5rem',
      textAlign: 'left',
      opacity: '0.9'
    },
    input: {
      padding: '1rem 0',
      border: 'none',
      borderBottom: '2px solid rgba(255,255,255,0.3)',
      backgroundColor: 'transparent',
      color: 'white',
      fontSize: '1rem',
      outline: 'none'
    },
    textareaGroup: {
      gridColumn: 'span 2',
      display: 'flex',
      flexDirection: 'column'
    },
    textarea: {
      padding: '1rem 0',
      border: 'none',
      borderBottom: '2px solid rgba(255,255,255,0.3)',
      backgroundColor: 'transparent',
      color: 'white',
      fontSize: '1rem',
      outline: 'none',
      minHeight: '100px',
      resize: 'vertical'
    },
    sendButton: {
      gridColumn: 'span 2',
      marginTop: '2rem',
      padding: '1rem 3rem',
      backgroundColor: 'transparent',
      border: '2px solid white',
      color: 'white',
      borderRadius: '25px',
      fontSize: '1.1rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    mapSection: {
      padding: '60px 0',
      backgroundColor: 'white'
    },
    mapContainer: {
      width: '100vw',
      position: 'relative',
      left: '50%',
      right: '50%',
      marginLeft: '-50vw',
      marginRight: '-50vw',
      overflow: 'hidden'
    }
  };

  return (
    <>
      <style>{`
        .input::placeholder,
        .textarea::placeholder {
          color: rgba(255,255,255,0.7);
        }
        
        .input:focus,
        .textarea:focus {
          border-bottom-color: white;
        }
        
        .send-btn:hover {
          background-color: white;
          color: #E67E22;
        }
        
        @media (max-width: 768px) {
          .contact-form-grid {
            grid-template-columns: 1fr !important;
          }
          .contact-grid {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
          .hero-title {
            font-size: 2.5rem !important;
          }
        }
      `}</style>
      
      <div style={styles.container}>
        <Header />
        
        {/* Hero Section with Farmland Background */}
        <section style={styles.heroSection}>
          <div style={styles.heroOverlay}></div>
          <div style={styles.heroContent}>
            <div style={styles.heroLabel}>SIRIDHARINI</div>
            <h1 style={styles.heroTitle} className="hero-title">CONTACT US</h1>
          </div>
        </section>

        {/* Contact Information */}
        <section style={styles.contactInfoSection}>
          <div style={styles.sectionContainer}>
            <div style={styles.contactGrid} className="contact-grid">
              <div style={styles.contactItem}>
                <div style={styles.iconContainer}>
                  <MapPin size={32} color="white" />
                </div>
                <h3 style={styles.contactTitle}>OFFICE ADDRESS</h3>
                <div style={styles.contactInfo}>
                  Rashtriya Vidyalaya Road, 2nd<br />
                  Block, Jaya Nagar East, Jayanagar,<br />
                  Bengaluru, Karnataka, India
                </div>
              </div>

              <div style={styles.contactItem}>
                <div style={styles.iconContainer}>
                  <Phone size={32} color="white" />
                </div>
                <h3 style={styles.contactTitle}>PHONE</h3>
                <div style={styles.contactInfo}>
                  +91 9448472706,<br />
                  +91 9036024568
                </div>
              </div>

              <div style={styles.contactItem}>
                <div style={styles.iconContainer}>
                  <Mail size={32} color="white" />
                </div>
                <h3 style={styles.contactTitle}>E-MAIL</h3>
                <div style={styles.contactInfo}>
                  <a href="mailto:connect@siridharini.com" style={{color: '#666', textDecoration: 'underline'}}>
                    connect@siridharini.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Functional Contact Form */}
        <ContactForm 
          pageSource="Contact Us Page"
          title="Get In Touch"
          onSubmitSuccess={(result) => {
            console.log('Contact form submitted successfully:', result);
          }}
          onSubmitError={(error) => {
            console.error('Contact form submission failed:', error);
          }}
        />

        {/* Map Section */}
        <section style={styles.mapSection}>
          <div style={styles.sectionContainer}>
            <h2 style={{fontSize: '2rem', textAlign: 'center', marginBottom: '2rem', color: '#2d5016'}}>
              Our Farm Location
            </h2>
          </div>
          {/* Full-width map container */}
          <div style={styles.mapContainer}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2835.0184872672107!2d77.65422287387703!3d12.620336053815237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae65e9bcb4a251%3A0x76b1620925218475!2sSiridharini!5e1!3m2!1sen!2sin!4v1784033535484!5m2!1sen!2sin"
              width="100%"
              height="500"
              style={{border: 0}}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              title="Siridharini Farmlands - 615/1, Gopasandra, Deverabetta Road"
            ></iframe>
          </div>
          <div style={styles.sectionContainer}>
            <div style={{textAlign: 'center', marginTop: '1rem', color: '#666'}}>
              📍 Siridharini Farmlands<br />
              615/1, Gopasandra, Deverabetta Road<br />
              Next to Reed Relays & Electronics, Thali Post Denkanekote
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default ContactUs;